module.exports = __webpack_public_path__ + "media/images/common/menu_accessory-dd8a89023fb2fe455ede0642e221c7cd.gif";